import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

export const RemoveButton = ({ removeString, removeTemplate }) => (
  <button className={styles.removeButton} onClick={removeTemplate}>
    {removeString}
  </button>
);

export default enhance(RemoveButton);
